import React from 'react';
import PageHero from './PageHero';
import { ArrowRight } from '../icons';
import gopeSamtani from '../assets/Gope Samtani.png';

const TIMELINE = [
  { year: '1950', desc: 'School founded in Jakarta to serve the international community.' },
  { year: '1978', desc: 'Official recognition by Ministry of Education as International School.' },
  { year: '1991', desc: 'Official recognition by Cambridge as First Cambridge International Examination Center in Jakarta.' },
  { year: '1996', desc: 'Authorized as an IB World School.' },
  { year: '2004', desc: 'Modern campus expansion with advanced facilities.' },
  { year: 'Today', desc: '1000+ students • 50+ nationalities • Global excellence.' },
];

export default function AboutUsPage({ setPage }) {
  return (
    <div className="w-full bg-white">
            {/* ── Hero ─────────────────────────────────────────────────────────────── */}
      <PageHero title={"Celebrating 75+ Years of Educational Excellence in Bali"} breadcrumbs={["Home","About Us","Our History"]} eyebrow={"Our History"} />


      {/* ── Intro Section ── */}
      <div className="max-w-[1440px] mx-auto px-6 lg:px-[120px] py-20 box-border">
        <div className="max-w-4xl mx-auto text-center flex flex-col gap-6">
          <div className="text-[12px] font-bold tracking-[0.16em] uppercase text-gold">Founded in 1950</div>
          <h2 className="m-0 font-heading font-medium text-[36px] leading-[1.15] text-navy tracking-[-0.015em]">
            A LEGACY OF LEARNING & EXCELLENCE
          </h2>
          <p className="text-[17px] leading-[1.7] text-ink/80">
            Established in 1950, the Gandhi Memorial Intercontinental School (GMIS) is dedicated to providing accessible, high-quality learning that prepares students to thrive as globally minded and responsible citizens.
          </p>
          <p className="text-[17px] leading-[1.7] text-ink/80">
            GMIS offers a diverse range of academic pathways, including the International Baccalaureate (IB), IGCSE, BSEISI, and Indonesian National Curriculum, serving a diverse and multicultural student community.
          </p>
          <p className="text-[17px] leading-[1.7] text-ink/80">
            GMIS operates under the umbrella of Gandhi Seva Loka (GSL), a pioneering organisation with a longstanding legacy of supporting learning and community development in Indonesia.
          </p>
        </div>
      </div>

      {/* ── Chairman's Message ── */}
      <div className="w-full bg-paper py-24 box-border">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-[120px]">
          <div className="flex flex-col lg:flex-row gap-16 items-start">
            <div className="lg:w-1/3 flex flex-col gap-8">
              <div className="flex flex-col gap-4">
                <div className="text-[11px] font-bold tracking-[0.2em] text-gold uppercase">Welcome Message</div>
                <h2 className="m-0 font-heading font-medium text-[32px] leading-[1.2] text-navy">
                  From the President of Gandhi Seva Loka
                </h2>
              </div>
              <img src={gopeSamtani} alt="Mr. Gope Samtani" className="w-full max-w-[280px] h-auto object-cover rounded-[8px] shadow-lg border-4 border-white mx-auto lg:mx-0" />
            </div>
            <div className="lg:w-2/3 flex flex-col gap-6 text-[16px] leading-[1.8] text-ink/80">
              <p>
                Dear Parents, Students, and Members of the Community,
              </p>
              <p>
                As the Chairman of one of the region’s oldest and most esteemed international schools, I am honoured to share our vision for the future. Rooted in the timeless Gandhian values of truth, non-violence, and self-discipline, together with the principles of Pancasila, we are committed to nurturing compassionate, responsible, and globally minded citizens.
              </p>
              <p>
                Our educational philosophy is aligned with the International Baccalaureate (IB) framework, with a strong emphasis on holistic development, academic excellence, and ethical awareness. We strive to support every student in reaching their full potential, encouraging them to explore their interests, develop their strengths, and pursue their aspirations with confidence.
              </p>
              <p>
                Looking ahead, we remain committed to strengthening learner-centred teaching, embracing innovative technologies, and fostering an inclusive environment that values diversity. By bringing together our rich heritage and a forward-looking approach, we aim to equip our students with the knowledge, character, and adaptability to thrive in an ever-changing world.
              </p>
              <div className="pt-4 flex flex-col gap-1">
                <span className="font-heading font-semibold text-[20px] text-navy">Mr. Gope Samtani</span>
                <span className="font-medium italic text-[15px]">President of Gandhi Seva Loka</span>
              </div>
            </div>
          </div>
        </div>
      </div>



      {/* ── Timeline Section ── */}
      <div className="w-full bg-navy py-24 box-border text-white relative overflow-hidden">
        {/* Subtle background decoration */}
        <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: 'radial-gradient(circle at 20% 50%, var(--gold) 0%, transparent 50%), radial-gradient(circle at 80% 80%, var(--gold) 0%, transparent 50%)' }} />
        
        <div className="max-w-[1200px] mx-auto px-6 lg:px-[120px] relative z-10">
          <div className="text-center mb-20">
            <h2 className="m-0 font-heading font-medium text-[40px] leading-[1.15] tracking-[-0.015em] text-white">
              Our Journey Through Time
            </h2>
            <div className="w-20 h-1 bg-gold mx-auto mt-6" />
          </div>

          <div className="relative">
            {/* Center line for desktop */}
            <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-white/20 -translate-x-1/2" />
            
            <div className="flex flex-col gap-12 md:gap-8">
              {TIMELINE.map((item, i) => {
                const isEven = i % 2 === 0;
                return (
                  <div key={i} className={`relative flex flex-col md:flex-row items-center gap-8 md:gap-0 ${isEven ? 'md:flex-row-reverse' : ''}`}>
                    
                    {/* Center node */}
                    <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 w-12 h-12 rounded-full bg-navy border-2 border-gold items-center justify-center z-10">
                      <div className="w-3 h-3 bg-gold rounded-full" />
                    </div>

                    {/* Content Box */}
                    <div className={`w-full md:w-1/2 ${isEven ? 'md:pl-16' : 'md:pr-16'}`}>
                      <div className={`p-8 rounded-[8px] bg-white/5 border border-white/10 backdrop-blur-sm transition-transform duration-300 hover:-translate-y-2 hover:bg-white/10 ${isEven ? 'text-left' : 'md:text-right text-left'}`}>
                        <div className="font-heading font-bold text-[36px] text-gold leading-none mb-4">{item.year}</div>
                        <div className="text-[16px] leading-[1.7] text-white/85">{item.desc}</div>
                      </div>
                    </div>

                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* ── CTA ── */}
      <div className="w-full py-24 bg-white text-center">
        <div className="flex flex-col items-center gap-6">
          <h2 className="m-0 font-heading font-medium text-[42px] leading-[1.15] text-navy tracking-[-0.015em]">
            Become Part of Our Story
          </h2>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (setPage) {
                setPage('coming-soon');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }}
            className="mt-4 flex items-center h-[46px] px-[26px] rounded-[3px] bg-navy text-white text-[12.5px] font-bold tracking-widest uppercase transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg cursor-pointer"
          >
            Apply Now
          </a>
        </div>
      </div>

    </div>
  );
}
